var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiptText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 18.75V26.3125C68.75 31.25 65.625 34.375 60.6875 34.375H50V12.5313C50 9.0625 52.8438 6.25 56.3125 6.25C59.7188 6.28125 62.8438 7.65625 65.0938 9.90625C67.3438 12.1875 68.75 15.3125 68.75 18.75Z",
    fill: "#392C7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.25 21.875V65.625C6.25 68.2188 9.18752 69.6875 11.25 68.125L16.5937 64.125C17.8437 63.1875 19.5938 63.3125 20.7188 64.4375L25.9062 69.6563C27.125 70.875 29.125 70.875 30.3438 69.6563L35.5937 64.4062C36.6875 63.3125 38.4375 63.1875 39.6563 64.125L45 68.125C47.0625 69.6562 50 68.1875 50 65.625V12.5C50 9.0625 52.8125 6.25 56.25 6.25H21.875H18.75C9.375 6.25 6.25 11.8438 6.25 18.75V21.875Z",
    fill: "#392C7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 30.4688H18.75C17.4688 30.4688 16.4062 29.4062 16.4062 28.125C16.4062 26.8438 17.4688 25.7812 18.75 25.7812H37.5C38.7812 25.7812 39.8438 26.8438 39.8438 28.125C39.8438 29.4062 38.7812 30.4688 37.5 30.4688Z",
    fill: "#392C7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1562 42.9688H21.0938C19.8125 42.9688 18.75 41.9062 18.75 40.625C18.75 39.3438 19.8125 38.2812 21.0938 38.2812H35.1562C36.4375 38.2812 37.5 39.3438 37.5 40.625C37.5 41.9062 36.4375 42.9688 35.1562 42.9688Z",
    fill: "#392C7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptText);
export default __webpack_public_path__ + "static/media/receipt-text.57dd828d3f5bb1525d7546ca3e3532d1.svg";
export { ForwardRef as ReactComponent };